"use client";

import { useState, useEffect } from "react";
import { getStoredConsent, type ConsentData } from "./consent";

/**
 * Returns consent state from localStorage, re-renders on changes.
 * undefined = not yet hydrated | null = no consent stored | ConsentData = consent exists
 */
export function useConsent(storageKey: string): ConsentData | null | undefined {
  const [consent, setConsent] = useState<ConsentData | null | undefined>(undefined);

  useEffect(() => {
    setConsent(getStoredConsent(storageKey));
    const handler = () => setConsent(getStoredConsent(storageKey));
    window.addEventListener("consentchange", handler);
    return () => window.removeEventListener("consentchange", handler);
  }, [storageKey]);

  return consent;
}
